import { render } from "./LocationsView.vue?vue&type=template&id=c8b5b284&scoped=true"
import script from "./LocationsView.vue?vue&type=script&lang=js"
export * from "./LocationsView.vue?vue&type=script&lang=js"

import "./LocationsView.vue?vue&type=style&index=0&id=c8b5b284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b5b284"]])

export default __exports__